export const CarsState = {
  dom: null,
};